export function debounce( fn ) {
	var timeout;
	
	return function debounced() {
		var _this = this,
				args  = arguments;

		// If there's a timer, cancel it
		if (timeout) {
			window.cancelAnimationFrame(timeout);
		}

		// Setup the new requestAnimationFrame()
		timeout = window.requestAnimationFrame(function () {
			fn.apply( _this, args );
		});
	}
}